module.exports = __webpack_public_path__ + "static/media/dali.54b94c7c.png";